module.exports = ".content.loading-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  min-height: 340px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/content-loader/content-loader.component.scss
// module id = ./src/app/components/content-loader/content-loader.component.scss
// module chunks = main